module.exports = __webpack_public_path__ + "img/logo.11704c42.png";